import React from 'react';
import ReactDOM from 'react-dom';
import '@assets/styles/reset.scss';
import '@assets/styles/common.scss';
import '@assets/styles/fonts/symbel/iconfont';
import '@assets/styles/fonts/iconfont';
// import VConsole from 'vconsole';
import { fetchGeoLocation, fetchSelectCity } from '@action/selectCity';
import { getUnionConfig } from '@action/home';
import { OK } from '@utils/config';
import { getQueryString, setCookie, unionFlag, checkUnifyShop } from '@utils/index';
import { checkXcx } from '@utils/checkXcx';
import injectionWindow from '@utils/lang';
import {
  initAddressDF, getCatchAddress, getLocation, checkEnv,
} from 'dflocationsdk';
import { Toast } from 'antd-mobile';
import App from './views/App';
import 'antd-mobile/dist/antd-mobile.css';
import { SUCCESS_CODES } from './utils/config';




function checkMiniCookie() {
  if (checkXcx() && getQueryString('from') === 'mini') {
    // 如果是小程序,回写cookie
    // const { hostname } = window.location; // m.test03.com
    // const position = hostname.indexOf('.'); // 1
    // const domain = hostname.slice(position); // .test03.com
    // setCookie('dfflone', null, 604800, '/', domain);
    // setCookie('dfflone', null, 604800, '/', hostname);
    // const dfflone = getQueryString('dfflone') || '';
    // setCookie('dfflone', dfflone, 604800, '/', domain);
    // setCookie('dfflone', dfflone, 604800, '/', hostname);
  }
}

function showError(error) {
  const city = '145, 上海';
  localStorage.setItem('city', city);
  switch (error.code) {
    case error.PERMISSION_DENIED:
      Toast.info('用户拒绝对获取地理位置的请求');
      break;
    case error.POSITION_UNAVAILABLE:
      Toast.info('位置信息是不可用的');
      break;
    case error.TIMEOUT:
      Toast.info('请求用户地理位置超时');
      break;
    default:
      Toast.info('未知错误');
      break;
  }
}

async function getCityInfo() {
  const localAddress = JSON.parse(getCatchAddress()) || null;
  const cityId = localAddress?.cityId || getQueryString('city');
  if (cityId) {
    const res = await fetchSelectCity({ city: cityId, cityId: cityId });
    if (!res) return;
    const cityData = SUCCESS_CODES.includes(res.code) ? `${res.cityId}, ${res.cityName}` : '145, 上海';
    localStorage.setItem('city', cityData);
    return;
  }

  if (localStorage.getItem('city')) return;

  if (!window.navigator.geolocation) {
    Toast.info('该浏览器不支持定位');
    const city = '145, 上海';
    localStorage.setItem('city', city);
    return;
  }

  const _env = checkEnv();
  getLocation(_env, async (value) => {
    // 有经纬度
    if (value?.location) {
      const res = await fetchGeoLocation({ longitude: position.coords.longitude, latitude: position.coords.latitude });
      const city = res && res.code === OK ? `${res.body.id},${res.body.name}` : '145, 上海';
      localStorage.setItem('city', city);
    } else {
      const city = '145, 上海';
      localStorage.setItem('city', city);
    }
  }, true);
}

function getUnion() {
  const union = window.location.host.split('.')[0] === 'corp' ? getQueryString('union') : '';
  setCookie('UNION', union, 604800, '/', window.location.hostname);
  if (!unionFlag()) {
    setCookie('df_lang', '', 604800, '/', window.location.hostname);
  }
}

async function getUnionConfigData() {
  const isUnion = window.location.host.split('.')[0] === 'corp';
  if (!isUnion && !checkUnifyShop()) return;
  const res = await getUnionConfig();
  if (!res || res.code !== 0) return;
  setCookie('UNION_ICON', res.icon, 604800, '/', window.location.hostname);
  setCookie('UNION_NAME', res.name, 604800, '/', window.location.hostname);
  setCookie('UNION_SCALE', res.scale, 604800, '/', window.location.hostname);
}
injectionWindow();
checkMiniCookie();

initAddressDF().then((data) => {
  getCityInfo();
  getUnion();
  getUnionConfigData();
});


// window.dfCollect = new DFCollectSDK();
// dfCollect.setIntervalPv(2000);

ReactDOM.render(<App />, document.getElementById('root'));
